<div mat-dialog-title>
  {{ data.name }}
</div>

<mat-drawer-container autosize class="h-70-vh">
  <div class="text-center f-20" *ngIf="selectedStep()?.index">
    {{ 'workInstruction.step' | translate: { count: selectedStep()?.index } }} -
    {{ selectedStep()?.name }}
  </div>
  <mat-drawer #drawer mode="side" opened="true" position="start">
    <mat-horizontal-stepper
      orientation="vertical"
      [selectedIndex]="selectedStepIndex()"
      (click)="onClickStep()"
      #stepper
    >
      <mat-step *ngFor="let step of store.steps(); let i = index; trackBy: trackByStepId" label="{{ step.id }}">
        <ng-template matStepLabel>
          <div>{{ step.name }}</div>
          <div class="d-flex align-content-start flex-column gap-025 pt-2">
            <mat-pill
              *ngIf="!step?.submission"
              text="{{ 'workInstructionStepper.status.notStarted' | translate }}"
            ></mat-pill>
            <mat-pill
              *ngIf="step?.submission && step?.submission?.endedAt === null && step.submission?.lastPlayedAt !== null"
              text="{{ 'workInstructionStepper.status.ongoing' | translate }}"
            ></mat-pill>
            <mat-pill
              *ngIf="step?.submission && step?.submission?.endedAt === null && step.submission?.lastPlayedAt === null"
              text="{{ 'workInstructionStepper.status.paused' | translate }}"
            ></mat-pill>
            <mat-pill
              *ngIf="step?.submission?.endedAt"
              text="{{ 'workInstructionStepper.status.completed' | translate }}"
              class="green"
            ></mat-pill>
            <div class="mx-1 d-flex justify-content-sm-between">
              <span class="f-11 fw-600 pt-1 stepper-label-color">
                {{ (stepIdToProgressesTimeMap$ | async)?.get(step.id)?.formattedTime || '00:00:00' }}
              </span>
              <span *ngIf="step.timeToComplete" class="f-11 fw-600 pt-1 stepper-label-color">
                {{ step.timeToComplete }}
              </span>
            </div>
            <mat-progress-bar
              *ngIf="step.targetDuration"
              mode="determinate"
              [value]="(100 * ((stepIdToProgressesTimeMap$ | async)?.get(step.id)?.time || 0)) / step.targetDuration"
              [ngStyle]="{
                '--mat-progress-bar-active-indicator-color':
                  (100 * ((stepIdToProgressesTimeMap$ | async)?.get(step.id)?.time || 0)) / step.targetDuration > 100
                    ? '#dc352b'
                    : '#22962d',
              }"
            >
            </mat-progress-bar>
            @if (store.stepCheckInUsers()[step.id]; as checkInUsers) {
              <div class="step-check-ins">
                @for (user of checkInUsers; track user.id) {
                  <app-text-avatar [text]="user.name"></app-text-avatar>
                }
              </div>
            }
          </div>
        </ng-template>
      </mat-step>
      <ng-template matStepperIcon="edit" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="number" let-index="index">
        {{ index + 1 }}
      </ng-template>
    </mat-horizontal-stepper>
  </mat-drawer>
  <h3 class="ps-3" *ngIf="store.dataLoading() === ELoadStatus.success && !selectedStep()?.form">
    {{ 'workInstructionStepper.emptyForm' | translate }}
  </h3>
  <app-scw-formio
    scwImageLoader
    *ngIf="selectedStep()?.form"
    [form]="selectedStep()?.form ?? {}"
    [submission]="selectedSubmission()?.formData"
    (submitted)="onSubmit($event)"
    (changed)="onChangedForm($event)"
    (isValid)="isFormValid = $event"
    (draft)="draft = $event"
  ></app-scw-formio>
</mat-drawer-container>
<mat-dialog-actions align="center">
  @let hastotalProcessCycleTime = store.totalProcessCycleTime() && store.actualDuration() > 0;
  <div [ngClass]="hastotalProcessCycleTime ? 'd-block w-100 mb-2' : ''">
    <div class="work-instruction-stepper-timer">
      <h6>{{ 'workInstructionStepper.totalProcessTime' | translate }}</h6>
      <div class="d-flex justify-content-sm-between">
        <span class="f-11 fw-600 pt-1 stepper-label-color">
          {{ (allStepsTotalTimer$ | async)?.totalTimer }}
        </span>
        <span *ngIf="store.totalTargetDuration()" class="f-11 fw-600 pt-1 stepper-label-color">
          {{ store.totalTimeToComplete() }}
        </span>
      </div>
      @let stepsProgressBarValue =
        (100 * ((allStepsTotalTimer$ | async)?.totalTimerAsSeconds || 0)) / (store.totalTargetDuration() || 1);
      <mat-progress-bar
        *ngIf="store.totalTargetDuration()"
        mode="determinate"
        [value]="stepsProgressBarValue"
        [ngStyle]="{
          '--mat-progress-bar-active-indicator-color': stepsProgressBarValue > 100 ? '#dc352b' : '#22962d',
        }"
      >
      </mat-progress-bar>
    </div>
  </div>

  <div *ngIf="hastotalProcessCycleTime">
    <div class="work-instruction-stepper-timer">
      <h6>{{ 'field.totalProcessCycleTime' | translate }}</h6>
      <div class="d-flex justify-content-sm-between">
        <span class="f-11 fw-600 pt-1 stepper-label-color">
          {{ formatedActualTime() }}
        </span>
        <span *ngIf="store.totalProcessCycleTime()" class="f-11 fw-600 pt-1 stepper-label-color">
          {{ formatedTotalProcessCycleTime() }}
        </span>
      </div>
      @let throughputProgressBarValue = (100 * store.actualDuration()) / (store.totalProcessCycleTime() || 1);
      <mat-progress-bar
        *ngIf="store.totalProcessCycleTime()"
        mode="determinate"
        [value]="throughputProgressBarValue"
        [ngStyle]="{
          '--mat-progress-bar-active-indicator-color': throughputProgressBarValue > 100 ? '#dc352b' : '#22962d',
        }"
      >
      </mat-progress-bar>
    </div>
  </div>
  <div class="buttons-wrapper">
    <button
      mat-stroked-button
      [disabled]="isSelectedStepTheFirstInOrder()"
      (click)="changeStep(selectedStepIndex() - 1)"
    >
      {{ 'button.previous' | translate }}
      <mat-icon>arrow_back</mat-icon>
    </button>
    <button
      mat-stroked-button
      [disabled]="store.combinedStatus() === ELoadStatus.loading"
      (click)="pauseOrResumeStepTimer()"
    >
      {{ timerData().buttonText | translate }}
      <mat-icon>{{ timerData().icon }}</mat-icon>
    </button>
    <span class="mx-3">{{ selectedItemAssignedWorkInstructionStepTimer$ | async }}</span>
    <button
      mat-stroked-button
      [disabled]="isSelectedStepTheLastInOrder()"
      (click)="changeStep(selectedStepIndex() + 1)"
    >
      {{ 'button.next' | translate }}
      <mat-icon>arrow_forward</mat-icon>
    </button>
    <button mat-stroked-button (click)="saveStep()">
      <mat-icon>save</mat-icon>
      {{ 'button.save' | translate }}
    </button>
    <button mat-flat-button *ngIf="!selectedStep()?.submission?.endedAt" (click)="onSubmit(draft)">
      <mat-icon>check_circle</mat-icon>
      {{ 'button.complete' | translate }}
    </button>
    <button matButton="tonal" mat-dialog-close>{{ 'button.close' | translate }}</button>
    <button mat-stroked-button type="button" (click)="onCheckInsClick()">
      <mat-icon>how_to_reg</mat-icon>
      {{ 'workInstruction.checkIn.checkInsTitle' | translate }}
      <span class="check-in-count-badge">{{ store.checkInCount() }}</span>
    </button>
  </div>
</mat-dialog-actions>
